// src/components/Headercomponents.jsx
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import '../App.css';

const Headercomponents = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const closeMenu = () => setIsMenuOpen(false);

  // 任意：メニュー開時に背景スクロールを止める（モバイルUX向上）
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  return (
    <header className="site-header">
      <div className="log">
        <h3>{t('header.name')}</h3>
      </div>

      <nav
        id="nav-menu"
        className={`nav-menu ${isMenuOpen ? 'is-open' : ''}`}
        aria-hidden={!isMenuOpen}
      >
        <ul>
          <li>
            <NavLink
              to="/"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
              end
            >
              {t('header.home')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/research"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {t('header.research')}
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/publication"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {t('header.publication')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/product"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {t('header.product')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/connect"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {t('header.connect')}
            </NavLink>
          </li>
          <li className="lang-switcher-mobile">
            <LanguageSwitcher />
          </li>
        </ul>
      </nav>

      <div className="header-right">
        <LanguageSwitcher />
      </div>

      <button
        className={`hamburger-button ${isMenuOpen ? 'is-open' : ''}`}
        onClick={() => setIsMenuOpen((v) => !v)}
        aria-expanded={isMenuOpen}
        aria-controls="nav-menu"
        aria-label={t('header.menuToggle')}
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </button>
    </header>
  );
};

export default Headercomponents;
